import { renderMathInElement } from 'latex-render';
let options = {
  delimiters: [
    { left: '$$', right: '$$', display: false },
    { left: '$', right: '$', display: false },
    { left: '\\(', right: '\\)', display: false },
    { left: '\\begin{equation}', right: '\\end{equation}', display: false },
    { left: '\\begin{align}', right: '\\end{align}', display: false },
    { left: '\\begin{alignat}', right: '\\end{alignat}', display: false },
    { left: '\\begin{gather}', right: '\\end{gather}', display: false },
    { left: '\\begin{CD}', right: '\\end{CD}', display: false },
    { left: '\\[', right: '\\]', display: false }
  ]
};
const pattern =
  /<sub>[\s\S]*<\/sub>|<sup>[\s\S]*<\/sup>|<u>[\s\S]*<\/u>|<u>[\s\S]*<\/u>|<p\b[^>]*>[\s\S]*<\/p>|<span\b[^>]*>(.*?)<\/span>|<img\b[^>]*>|<br>|<br\/>|&gt;|&lt;|&emsp;|&nbsp;|\$\$|\$/;
const setTextOrHtml = (el, value) => {
  if (pattern.test(value)) {
    value ? (el.innerHTML = value) : "";
  } else {
    if (value === undefined) {
    } else {
      el.innerText = value;
    }
  }
};
const latex = {
  bind(el, binding, vnode) {
    binding.value && setTextOrHtml(el, binding.value);
    renderMathInElement(el, options);
  },
  inserted(el, binding, vnode) {
    binding.value && setTextOrHtml(el, binding.value);
    renderMathInElement(el, options);
  },
  update(el, binding, vnode, oldVnode) {
    binding.value && setTextOrHtml(el, binding.value);
    renderMathInElement(el, options);
  }
};
export default latex;
